module.exports = __webpack_public_path__ + "img/stop.280cd3ef.svg";